import { useEffect, useState } from "react";
import BaseSiteLayout from "../../layouts/BaseSiteLayout/BaseSiteLayout";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ExternalLink, Star, CodeXml } from "lucide-react";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";
import Typography from "../../components/Typography/Typography";
import { StarFill } from "../../Icons/StarFill";
import blogData from "../../routes/Blog/blogData.json";
import BlogCard from "../../routes/Blog/BlogCard";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ApiManager from "../../api/ApiManager";
import { Toaster, toast } from "react-hot-toast";

export default function Landing() {
  const navigate = useNavigate();

  const GOOGLE_CLIENT_ID =
    "339987226679-c9fn0plo28plccf5uh7ucoag2s053v4m.apps.googleusercontent.com";
  const REDIRECT_URI = "https://getathena.app/client/library";
  const COGNITO_CLIENT_ID = "bo24stke7qeq3l76saqttte3j";
  const COGNITO_AUTH_URL = `https://eu-west-3cee3sfvyn.auth.eu-west-3.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URI}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=openid+profile+email`;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleOneTapResponse,
          auto_select: true,
          cancel_on_tap_outside: false,
          context: "signin",
        });

        window.google.accounts.id.prompt((notification) => {
          console.log("One Tap Debug:", notification);
        });
      } else {
        console.log("Google object is not available");
      }
    };

    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleOneTapResponse = (response) => {
    if (response && response.credential) {
      window.location.href = COGNITO_AUTH_URL;
    }
  };

  const isMobile = window.innerWidth < 768;

  return (
    <>
      <Helmet>
        <title>Athena - La piattaforma per la tua tesi</title>
        <meta
          name="description"
          content="Athena è la piattaforma intelligente che ti aiuta a scrivere, organizzare e consegnare la tesi senza stress."
        />
        <meta
          property="og:title"
          content="Athena - Scrivere la tesi non è mai stato così facile"
        />
        <meta
          property="og:description"
          content="Scopri Athena: ricerca smart, roadmap chiara, bibliografia automatica e molto altro."
        />
        <meta
          property="og:image"
          content="https://athena-dev-pulse.s3.eu-west-3.amazonaws.com/sources/images/ogimage.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIARSU7KNZSFHKXP3WO%2F20250508%2Feu-west-3%2Fs3%2Faws4_request&X-Amz-Date=20250508T123247Z&X-Amz-Expires=300&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEM3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMyJGMEQCIANMha6QtGGCSnF%2F%2BA%2F2gAXtJbFsuuxbVfeAaugauJRzAiBACvCfQWfBgk03bdUtbQ68zIH6nGrqLf%2Bc2oWdaaSYWCrtAgh2EAAaDDEwODc4MjA1NTAxMiIM%2B82FQTlxwqWbXttEKsoC1fRChzpJI5%2BMD14iCess6PQfhyoAl3HnanTIBOptxd5R2R8GI%2Bsu2U%2BooMPx5%2FY76sWBaN9CtcP4AR5Ky8NTheQCSqUQtJcMJTmyJlAiTPtJFFESTsMtfO6Pyis%2Fju4%2BmHklBbYXVyxiIC00LqkQzfLPMFDD4OZzQm1sjigWrrwo29l7Ligr%2BxwDj0unPmPoItQatnq3vAOagqBb68LPa52T3XYdmNCdvWxOymyHsX6cW2ZsbJJq8fvuf7sp1Uazom8bcz1Yd5IpdeFsVim514MEIs9QYgJ22QhPLzEfB4oEVJ4yOO%2FxAjgFbX98gndY5uj0th9QfVIPQHQmwv%2Fha2k%2FUJmK%2BVFRM%2BPQYBlQMtKoRL%2BnhfHw7ihV4Jdw34y0y1fcVd7%2BHuO6KpFuCylIr7vvxnKfJVmE2xEx8rG%2BjkIc2mzqIukhS7u1MKzI8sAGOq4C4DSH2IGZddrlgyZt1m8cG8FDFnp%2BRmi2GFJuGskyPva0r2D%2BqZ7P7cmUi0IIG%2BC92ablTJBE290rzaLYsqG58R5ZiVdomTTyUxPl42KjYSmGu7sgrg2oCBkPMNZsVy5O9v4ndIKc8HNRwpSVGUCFPs5EpPs3%2BIufLS1%2BZN%2BjrkHI5CDnxo%2Fu%2FijEt1kUYtO4vh2FZ2AMy6%2BzG9hbfVDEVVI5tOFkbV1vaRit6AQ%2F14lEM8tyOsEyB8dyeGxBI4NWJ%2BDnyS4CvUtXHPDcwY529g%2FtB%2F0YxIDdK8WWPf4I97SYVmnzgXoZPUZCKOg30t8Wsiu1ME%2FWFI8FHdfPIPaiXh5Q8i0y4esguHIL32Zh9UpN7FjVrotyO7UbYfjguLQ87dC%2B02v6eiSK%2Bi8mugQ%3D&X-Amz-Signature=b49fa25f43dd55925769f8a607cb5283c70f80e8a4ff01d1bcfa13c0ee871e48&X-Amz-SignedHeaders=host&response-content-disposition=inline"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://tuo-dominio.com/" />
      </Helmet>

      <BaseSiteLayout isBeta={true}>
        <div className="flex flex-col gap-[80px] md:gap-[120px] pb-14">
          <div className="md:-mt-12 md:mx-auto w-full md:px-20 flex flex-col items-center gap-8 md:gap-12">
            <Button
              size="sm"
              type="bw"
              text="La versione 0.2.9 è ora disponibile!"
              licon={<ExternalLink size={16} />}
              onClick={() => navigate("/login")}
            />

            <div className="flex flex-col gap-6 items-center">
              <Typography
                size="40"
                desktopSize="82"
                weight="sb"
                family="serif"
                align="center"
              >
                Tutta la tua tesi {!isMobile && <br /> } in un unico posto
              </Typography>
              <Typography
                size="16"
                desktopSize="20"
                weight="md"
                align="center"
                color="gray-600"
              >
                Athena è la piattaforma intelligente che semplifica la tua tesi,
                così puoi concentrarti solo sui contenuti.
              </Typography>
            </div>
            {/* <Button
              size="sm"
              type="color"
              text="Richiedi accesso alla beta"
              licon={<CodeXml size={20} />}
              onClick={() =>
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                })
              }
            /> */}
            <img
              className="w-screen"
              src={`assets/images/illustrations/hero_image${
                isMobile ? "_sm" : ""
              }.png`}
              alt="Athena Hero"
            />
          </div>
          <div className="flex flex-col gap-[80px] md:gap-[120px] md:px-20">
            <FeatureSection />

            <BlogSection />

            <ReviewsSection />
          </div>

          <ExploreAthenaCTA />
        </div>
        <div id="googleOneTap" className="absolute top-4 right-4" />
      </BaseSiteLayout>
    </>
  );
}

function FeatureSection() {
  const features = [
    {
      title: "Fonti Sempre Sotto Controllo",
      description:
        "Salva, organizza e tieni traccia di tutte le tue fonti e citazioni in un unico spazio. Tutto pronto e ordinato per la bibliografia finale.",
      image: "assets/images/illustrations/ft_1.png",
      id: 1,
    },
    {
      title: "Ricerca Smart",
      description:
        "Trova articoli accademici, documenti ufficiali e fonti affidabili in pochi click grazie all’AI. Zero caos, solo risultati mirati.",
      image: "assets/images/illustrations/ft_2.png",
    },
    {
      title: "Struttura Automatica",
      description:
        "Genera l’indice della tua tesi in modo semplice e veloce. Crea una struttura solida e organizzata, senza perdite di tempo.",
      image: "assets/images/illustrations/ft_3.png",
    },
    {
      title: "Roadmap",
      description:
        "Segui un percorso chiaro fino alla consegna: suddividi il tuo progetto in step concreti e ti guida fase dopo fase.",
      image: "assets/images/illustrations/ft_4.png",
    },
  ];

  return (
    <div className="flex flex-col items-center gap-8 md:gap-12">
      <div className="flex flex-col gap-6 items-center md:px-36">
        <Typography
          size="40"
          desktopSize="64"
          weight="sb"
          family="serif"
          align="center"
        >
          Tutto quello che ti serve, davvero
        </Typography>
        <Typography
          size="16"
          desktopSize="20"
          weight="md"
          align="center"
          color="gray-600"
        >
          Abbiamo creato Athena per semplificarti la vita durante la tesi: dalla
          ricerca delle fonti alla gestione delle idee, fino all’organizzazione
          di tutto il lavoro. Tutto quello che ti serve, in un unico spazio
          facile e veloce da usare.
        </Typography>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white p-4 md:p-6 rounded-[12px] flex flex-col gap-6 md:gap-9 w-full"
          >
            <div className="flex flex-col gap-2 md:gap-3">
              <Typography size="20" desktopSize="28" weight="sb" align="left">
                {feature.title}
              </Typography>
              <Typography
                size="12"
                desktopSize="20"
                weight="md"
                align="left"
                color="gray-600"
              >
                {feature.description}
              </Typography>
            </div>
            <img
              className="w-full"
              src={feature.image}
              alt={`Athena ${feature.title}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function BlogSection() {
  const { blogItems } = blogData;

  return (
    <div className="flex flex-col items-center gap-8 md:gap-12">
      <Typography
        size="40"
        desktopSize="64"
        weight="sb"
        family="serif"
        align="center"
      >
        Dal nostro blog
      </Typography>

      <div className="flex gap-9 flex-col md:flex-row items-top justify-center w-full">
        {[...blogItems]
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 3)
          .map((blogItem) => (
            <Link to={`/blog/${blogItem.id}`} key={blogItem.id}>
              <BlogCard blogItem={blogItem} />
            </Link>
          ))}
      </div>
    </div>
  );
}

function ReviewsSection() {
  const reviews = [
    {
      nome: "Gaia Scuteri",
      universita: "Università di Milano, Lettere",
      testo:
        "Con la tesi in Letteratura Comparata ero in difficoltà a gestire le numerose fonti bibliografiche. Athena mi ha sorpresa per quanto è intuitiva: mi ha permesso di catalogare facilmente le citazioni e creare una struttura logica per i capitoli. Ho risparmiato almeno due settimane di lavoro e la mia relatrice ha apprezzato molto l'organizzazione del materiale. Non avrei mai consegnato in tempo senza questo strumento.",
      valore: 5,
      image: "assets/images/illustrations/user01.png",
    },
    {
      nome: "Andrea Costantin",
      universita: "Università di Roma, Ingegneria",
      testo:
        "Per la mia tesi in Ingegneria Civile dovevo gestire molti dati tecnici e riferimenti normativi. Athena mi ha aiutato a organizzare la documentazione in modo sistematico e a creare una timeline realistica. La funzione di ricerca ha velocizzato il recupero delle informazioni nei momenti critici. Ho completato la tesi con due settimane di anticipo rispetto alla scadenza, cosa che sembrava impossibile all'inizio.",
      valore: 4,
      image: "assets/images/illustrations/user02.png",
    },
  ];

  const isMobile = window.innerWidth < 768;

  return (
    <div className="flex flex-col items-center gap-8 md:gap-12">
      <div className="flex flex-col gap-6 items-center md:px-36">
        <Typography
          size="40"
          desktopSize="64"
          weight="sb"
          family="serif"
          align="center"
        >
          Dicono di noi
        </Typography>
        <Typography
          size="16"
          desktopSize="20"
          weight="md"
          align="center"
          color="gray-600"
        >
          Leggi le esperienze di altri studenti che hanno usato Athena per
          scrivere la loro tesi: storie vere di chi ha risparmiato tempo e
          fatica grazie a un metodo semplice e organizzato.
        </Typography>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 w-full">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-[12px] flex flex-col gap-6 w-full"
          >
            <div className="flex gap-6 items-top w-full">
              <div className="w-14 h-14 aspect-square pt-1 rounded-[8px] border-2 border-gray-150 bg-gray-100 flex items-center justify-center overflow-hidden">
                <img
                  className="max-w-full max-h-full object-contain"
                  src={review.image}
                  alt="User"
                />
              </div>
              <div className="flex flex-col gap-1">
                <Typography size="24" destkopSize="28" weight="sb" align="left">
                  {review.nome}
                </Typography>
                <Typography
                  size="16"
                  desktopSize="20"
                  weight="md"
                  color="gray-600"
                  align="left"
                >
                  {review.universita}
                </Typography>
              </div>
            </div>

            <Typography size="16" desktopSize="20" weight="md" align="left">
              {review.testo}
            </Typography>

            <div className="flex gap-2 items-center">
              <Typography size="16" desktopSize="20" weight="md" align="left">
                {review.valore}
              </Typography>
              <StarFill size={isMobile ? 16 : 20} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ExploreAthenaCTA() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const api = new ApiManager();

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (value) => {
    // Verifica che l'email non sia vuota
    if (!value || value.trim() === "") {
      toast.error("Inserisci un'email valida");
      return;
    }

    // Chiamata API solo quando si invia l'email
    api
      .post("/waiting-list", { email: value })
      .then((response) => {
        toast.success("Email aggiunta alla lista d'attesa!");
        // Opzionalmente puoi resettare l'input dopo l'invio
        setEmail("");
      })
      .catch((error) => {
        console.error("Errore durante l'aggiunta dell'email:", error);
        toast.error("Errore durante l'aggiunta dell'email. Riprova.");
      });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 bg-accent rounded-[24px] overflow-hidden h-full relative">
      <Toaster />
      <div className="md:col-span-5 flex flex-col gap-6 justify-between py-8 px-6 md:py-14 md:ps-14 z-20">
        <div className="flex flex-col gap-6">
          <Typography
            size="48"
            desktopSize="64"
            weight="sb"
            family="serif"
            align="left"
            color="white"
          >
            La beta è in arrivo!
          </Typography>

          <Typography
            size="16"
            desktopSize="20"
            weight="md"
            align="left"
            color="white"
          >
            Lascia la tua email per essere tra i primi a provare Athena: il
            planner pensato per studenti come te. Aiutaci a costruire qualcosa
            di rivoluzionario (e sii parte della community che lo sostiene!).
          </Typography>
        </div>

        <Input
          placeholder="Inserisci la tua email"
          value={email}
          onChange={handleInputChange}
          onSubmit={() => handleSubmit(email)}
        />
      </div>

      {/* Resto del codice invariato */}
      <div className="hidden md:block absolute bottom-12 col-start-5">
        <img
          src="assets/images/illustrations/cta_1.1.png"
          alt="Athena CTA Gift"
          className="w-48 object-contain"
        />
      </div>

      <div className="md:col-span-7 relative h-full flex items-end -pt-24 md:pt-14 z-20">
        <div className="block md:hidden mx-auto -mb-8 w-32">
          <img
            src="assets/images/illustrations/cta_1.1.png"
            alt="Athena CTA Gift"
            className="w-full object-contain"
          />
        </div>

        <img
          src="assets/images/illustrations/cta_1.png"
          alt="Athena CTA"
          className="ps-6 md:ps-0 w-full h-auto object-contain"
        />
      </div>
    </div>
  );
}
